import React, { useContext } from "react";
import { AnalyticsActionType } from "../app/contexts/Analytics/types";
import { AppContext } from "../app/store";

export const ExternalLink = ({
  href,
  text,
}: {
  href: string;
  text: string;
}) => {
  const { dispatch } = useContext(AppContext);
  return (
    <a
      href={href}
      onClick={() => {
        dispatch({
          type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
          settings: {
            linkText: text,
            linkUrl: href,
            text: text,
          },
        });
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );
};
